import React, { useState } from "react";
import { Accordion } from "react-bootstrap";


const Acccordion = ({ items, defaultActiveKey, alwaysOpen, className, Open, Close, onClick }) => {
    console.log("items", items);
    
    const [activeKey, setActiveKey] = useState();

    const handleToggle = (key, item) => {
        console.log("item", item);
        
        setActiveKey(activeKey === key ? null : key);
        if (onClick) {
            onClick(item); 
        }
    };
    return (
        <Accordion
            defaultActiveKey={defaultActiveKey}
            alwaysOpen={alwaysOpen}
            className={`${className}`}
        >
            {items?.map((item, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                    <Accordion.Header onClick={() => handleToggle(index.toString(), item)}>
                        <div className="acc-icons">
                            <span className="acc-icn">{item.icon}</span>
                        </div>
                        <div className="acc-header-blk">
                            <h4 className="exado-title-three">{item.title}</h4>
                            {activeKey === index.toString() ? Open : Close}
                        </div>

                    </Accordion.Header>
                    <Accordion.Body className="exado-subTitle-two">{item.content}</Accordion.Body>
                </Accordion.Item>
            ))}
        </Accordion>
    );
};

export default Acccordion;
